<template>
    <RouterView />
</template>

<script setup>
import { RouterView } from 'vue-router';
import { useGlobalStore } from '@hc/stores/useGlobalStore';
import { useUserStore } from '@hc/stores/useUserStore';

const props = defineProps({
    globals: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    additional: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const globalStore = useGlobalStore();
const userStore = useUserStore();

globalStore.setProps(props.globals);
userStore.setProps(props.additional);
</script>
